import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem("lang") || "se"); // Load from localStorage
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    localStorage.setItem("lang", language); // Save selected language
    axios
      .get(`/locales/${language}.json`)
      .then((res) => setTranslations(res.data))
      .catch((err) => console.error("Error loading translations:", err));
  }, [language]);

  return (
    <LanguageContext.Provider value={{ translations, language,setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
